<!--component html goes here -->
<div class="flex-center p-5 min-vh-100">
  <a [routerLink]="'/dashboard'">
    <img src="../assets/images/logo.main.svg" />
  </a>
</div>